export const SET_VALUE = 'INTERCOM/SET_VALUE';
